import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Hyperlink } from "@ebsco-ui/ebsco-ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-solid-svg-icons";
import { isRtlLang } from "rtl-detect";
import { injectIntl } from "react-intl";

import "./return-link.scss";

const getIcon = locale => (isRtlLang(locale) ? faArrowRight : faArrowLeft);

const ReturnLink = ({
  isExternalLink,
  children,
  onClick,
  url,
  intl: { locale }
}) => (
  <div className="return-link">
    {isExternalLink ? (
      <Hyperlink id="return-link" onClick={onClick} href={url} target="_self">
        <FontAwesomeIcon className="return-link__icon" icon={getIcon(locale)} />
        {children}
      </Hyperlink>
    ) : (
      <Link
        id="return-link"
        className="return-link__link"
        onClick={onClick}
        to={url}
      >
        <FontAwesomeIcon className="return-link__icon" icon={getIcon(locale)} />
        {children}
      </Link>
    )}
  </div>
);

ReturnLink.propTypes = {
  isExternalLink: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export { ReturnLink };
export default injectIntl(ReturnLink);
